/* eslint-disable */
import axios from '@/services/axios'

export default {
    listFirstClass(search, source) {
        return axios.get("/brandpin/getFirstClasses", { params: search, cancelToken: source.token });
    },
    listMiddleClass(search, source) {
        return axios.post("/brandpin/getMiddleClasses", search, { cancelToken: source.token });
    },
    listBrand(search, source) {
        return axios.post("/brandpin/getBrands", search, { cancelToken: source.token });
    },
    listGubun(search, source) {
        return axios.post("/brandpin/getGubuns", search, { cancelToken: source.token });
    },
    getBrandPinData(search, source) {
        return axios.post("/brandpin/getBrandPinData", search, { cancelToken: source.token });
    },
    getBrandPinDataExp(search, source) {
        return axios.post("/brandpin/getBrandPinDataExp", search, { cancelToken: source.token });
    },
    getBrandPinDataTable(search, source) {
        return axios.post("/brandpin/getBrandPinDataTable", search, { cancelToken: source.token });
    },
    getBrandPinDataTableExp(search, source) {
        return axios.post("/brandpin/getBrandPinDataTableExp", search, { cancelToken: source.token });
    },
    getBrandPinDataTableOne(search, source) {
        return axios.post("/brandpin/getBrandPinDataTableOne", search, { cancelToken: source.token });
    },
    getBrandPinDataTableOneExp(search, source) {
        return axios.post("/brandpin/getBrandPinDataTableOneExp", search, { cancelToken: source.token });
    },
};
